import { render } from "./FormElement.vue?vue&type=template&id=86073e02&scoped=true"
import script from "./FormElement.vue?vue&type=script&lang=js"
export * from "./FormElement.vue?vue&type=script&lang=js"

import "./FormElement.vue?vue&type=style&index=0&id=86073e02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86073e02"]])

export default __exports__